import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CustomerPortalButtonType } from 'api/customer-portal/theme-api';
import { ProjectConversationId, ProjectId } from 'api/models';
import { ProjectConversation } from 'api/project-conversations';
import { Button } from 'components/atoms/button/button';
import { CpButton } from 'components/organisms/customer-portal/components/cp-button';
import { useUser } from 'hooks/use-user';
import { BodyShort01 } from 'ozone/atoms';
import { useAddMembersProjectConversationsMutation } from 'queries/project-wide-conversation';

interface Props {
  conversation: ProjectConversation;
  projectId: ProjectId;
  onSuccess?: () => void;
}

const Wrapper = styled.div`
  padding: var(--spacing-07) var(--spacing-07) var(--spacing-09);
  background-color: var(--coolest-gray-10);
`;

const Text = styled(BodyShort01)`
  margin-bottom: var(--spacing-05);
  display: block;
`;

const CpText = styled(BodyShort01)`
  margin-bottom: var(--spacing-05);
  display: block;
  font-family: var(--cp-para-small-font-family);
`;

export const JoinChannel: FC<Props> = ({
  conversation,
  projectId,
  onSuccess,
}) => {
  const { mutate: addMembersToConversationMuatate, isLoading: isMemberAdding } =
    useAddMembersProjectConversationsMutation(
      projectId,
      ProjectConversationId(conversation?.conversationId),
    );
  const { user } = useUser();
  const onJoin = () => {
    addMembersToConversationMuatate({
      addAllMembersToConversation: false,
      members: [
        {
          user,
        },
      ],
    });
    onSuccess?.();
  };

  return (
    <Wrapper>
      <Text>
        <FormattedMessage
          id="projects.conversations.join_title"
          values={{
            strong: (chunks) => <strong>{chunks}</strong>,
            conversationName: conversation?.conversationName,
          }}
        />
      </Text>
      <Button type="primary" onClick={onJoin} loading={isMemberAdding}>
        <FormattedMessage id="projects.conversations.join" />
      </Button>
    </Wrapper>
  );
};
export const CPJoinChannel: FC<Props> = ({
  conversation,
  projectId,
  onSuccess,
}) => {
  const { mutate: addMembersToConversationMuatate, isLoading: isMemberAdding } =
    useAddMembersProjectConversationsMutation(
      projectId,
      ProjectConversationId(conversation?.conversationId),
    );
  const { user } = useUser();
  const onJoin = () => {
    addMembersToConversationMuatate({
      addAllMembersToConversation: false,
      members: [
        {
          user,
        },
      ],
    });
    onSuccess?.();
  };

  return (
    <Wrapper>
      <CpText>
        <FormattedMessage
          id="projects.conversations.join_title"
          values={{
            strong: (chunks) => <strong>{chunks}</strong>,
            conversationName: conversation?.conversationName,
          }}
        />
      </CpText>
      <CpButton
        onClick={onJoin}
        loading={isMemberAdding}
        cpType={CustomerPortalButtonType.Primary}
      >
        <FormattedMessage id="projects.conversations.join" />
      </CpButton>
    </Wrapper>
  );
};
